import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchRegulatoryBodies} from "./actions";
import ListView from "../common/ListView";
import {Link} from "react-router-dom";
import DeleteRegulatoryBodyModal from "./DeleteRegulatoryBodyFormModal";
import {showDeleteRegulatoryBodyModal} from "../RegulatoryBody/actions";

class RegulatoryBodiesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    search: PropTypes.object.isRequired,
    deleteRegulatoryBodyModalVisible: PropTypes.bool.isRequired,
    /* actions */
    searchRegulatoryBodies: PropTypes.func.isRequired,
    showDeleteRegulatoryBodyModal: PropTypes.func.isRequired,
  };

  render() {
    const {
      history, searchRegulatoryBodies, search: {searching, pagination, filters, sorter, searchFilter, results},
      deleteRegulatoryBodyModalVisible
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, record) => <span><Link
          to={`/regulatory-reporting/body/categories/${record.regulatoryBodyId}`}>Categories</Link> | <Link
          to={`/regulatory-reporting/update-body/${record.regulatoryBodyId}`}>Edit</Link> | <a
          onClick={() => this.props.showDeleteRegulatoryBodyModal(record)}>Delete</a> </span>
      }
    ];
    return (<React.Fragment>
      {deleteRegulatoryBodyModalVisible && <DeleteRegulatoryBodyModal onDelete={() => this.listView.refresh()}/>}
      <ListView
        ref={ref => this.listView = ref}
        title="Regulatory Bodies"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchRegulatoryBodies}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/regulatory-reporting/add-body')}
        rowKey="regulatoryBodyId"
      />
    </React.Fragment>);
  }
}

const mapStateToProps = state => ({
  loading: state.regulatoryBody.regulatoryBodiesLoading,
  search: state.regulatoryBody.search,
  deleteRegulatoryBodyModalVisible: state.regulatoryBody.deleteRegulatoryBodyModalVisible,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchRegulatoryBodies,
  showDeleteRegulatoryBodyModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(RegulatoryBodiesPage);



// WEBPACK FOOTER //
// ./src/RegulatoryBody/RegulatoryBodiesPage.js